import { VISITOR_FORM_URL } from "@/constants/visitorForm";

export default function VisitorFormIframe({ className = "", testId = "visitor-form-iframe" }) {
  return (
    <iframe
      src={VISITOR_FORM_URL}
      title="Bizlem visitor form"
      data-testid={testId}
      className={`w-full min-h-[720px] border-0 ${className}`.trim()}
    />
  );
}
